import React from "react";
import Typewriter from "typewriter-effect";
import { useTranslation } from "react-i18next";
import { useData } from "../../context/DataContext";

function Type() {
  const { t, i18n } = useTranslation();
  const { profile } = useData();
  const lang = i18n.language.split("-")[0];

  // Get typing texts from profile or use defaults
  const defaultTexts = [
    t("type_1", "Frontend Developer"),
    t("type_2", "Full Stack Developer"),
    t("type_3", "Cybersecurity Enthusiast"),
    t("type_4", "JavaScript Specialist"),
  ];

  const typingTexts =
    profile?.typingTexts?.[lang]?.length > 0
      ? profile.typingTexts[lang]
      : defaultTexts;

  return (
    <Typewriter
      options={{
        strings: typingTexts,
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
